import FednowTabs from "./FednowTabs";
import PaymentTable from "./PaymentTable";
import { useParams } from "react-router-dom";

type IdParam = {
  id: string | undefined;
};

export default function FednowPaymentContainer() {
  const { id } = useParams<IdParam>();

  return (
    <FednowTabs tab="payments">
      <div className="padding--y" style={{ display: "block" }}>
        <PaymentTable selectedId={id} />
      </div>
    </FednowTabs>
  );
}
